import "./menu.css";
import logo from "../../assets/image/logo.svg";
import icoscroll from "../../assets/image/icoscroll.png";
import { useContext, useEffect, useRef, useState } from "react";
import ConfigContext from "../../context/config/ConfigContext";
import Swiper from "swiper";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import menuApi from "../../services/menuApi";
import MenuLightbox from "../../components/lightbox/MenuLightbox";

function Menu() {
	const { strings } = useContext(ConfigContext);
	const [headerClassName, setHeaderClassName] = useState("");
	const [images, setImages] = useState([]);
	const [lightboxIndex, setLightboxIndex] = useState(null);
	const swiperRef = useRef(null);

	useEffect(() => {
		menuApi
			.fetchMenuImages()
			.then((res) => {
				if (res.data?.meta?.success && Array.isArray(res.data.data)) {
					setImages(res.data.data);
				}
			})
			.catch(() => {});
	}, []);

	// Init / reinit Swiper after images are rendered
	useEffect(() => {
		if (images.length === 0) return;
		if (swiperRef.current) {
			swiperRef.current.destroy(true, true);
		}
		swiperRef.current = new Swiper(".swiper", {
			modules: [Navigation, Pagination, Scrollbar],
			slidesPerView: 1,
			spaceBetween: 0,
			loop: true,
			pagination: { el: ".swiper-pagination" },
			navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
			scrollbar: { el: ".swiper-scrollbar" },
		});
	}, [images]);

	useEffect(() => {
		const handleScroll = () => {
			if (document.querySelector(".category_container")?.getBoundingClientRect()?.y <= 0) {
				setHeaderClassName("is_sticky");
			} else {
				setHeaderClassName("");
			}
		};
		handleScroll();
		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<main>
			<div className="logo_container">
				<img src={logo} className="logo" alt="logo" />
			</div>

			<div className="swiper">
				<div className="swiper-wrapper">
					{images.map((img, idx) => (
						<div
							key={img.id}
							className="swiper-slide swiper-slide--tappable"
							onClick={() => setLightboxIndex(idx)}
						>
							<img src={img.url} alt={`Menu ${img.id + 1}`} />
						</div>
					))}
				</div>

				<div className="swiper-button-prev"></div>
				<div className="swiper-button-next"></div>
				<div className="swiper-scrollbar"></div>
			</div>

			{lightboxIndex !== null && (
				<MenuLightbox
					images={images}
					initialIndex={lightboxIndex}
					onClose={() => setLightboxIndex(null)}
				/>
			)}

			<div className="div_nb">
				<p className="nb_sotto">{strings?.subheader1}</p>
				<p className="nb_sotto">{strings?.dessert}</p>
				<p className="nb_sotto">{strings?.subheader2}</p>
				<p className="nb_sotto">{strings?.subheader3}</p>
				<p className="nb_sotto">{strings?.subheader4}</p>
				<p className="nb_sotto">{strings?.subheader5}</p>
			</div>
		</main>
	);
}

export default Menu;
